"use strict";

var _style = require("styled-jsx/style");

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __extends = undefined && undefined.__extends || function () {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var graphql_1 = require("graphql");
var cx = require("classnames");
var FieldDoc_1 = require("graphiql/dist/components/DocExplorer/FieldDoc");
var SchemaDoc_1 = require("./DocExplorer/SchemaDoc");
var SearchBox_1 = require("./DocExplorer/SearchBox");
var SearchResults_1 = require("graphiql/dist/components/DocExplorer/SearchResults");
var TypeDoc_1 = require("graphiql/dist/components/DocExplorer/TypeDoc");
var DocExplorer = function (_super) {
    __extends(DocExplorer, _super);
    function DocExplorer(props) {
        var _this = _super.call(this, props) || this;
        _this.handleNavBackClick = function () {
            _this.setState({ navStack: _this.state.navStack.slice(0, -1) });
        };
        _this.handleClickTypeOrField = function (typeOrField) {
            _this.showDoc(typeOrField);
        };
        _this.handleSearch = function (value) {
            _this.showSearch({
                name: 'Search Results',
                searchValue: value
            });
        };
        _this.state = { navStack: [], searchValue: undefined };
        return _this;
    }
    DocExplorer.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return this.props.schema !== nextProps.schema || this.state.navStack !== nextState.navStack || this.state.searchValue !== nextState.searchValue;
    };
    DocExplorer.prototype.render = function () {
        var schema = this.props.schema;
        var navStack = this.state.navStack;
        var navItem;
        if (navStack.length > 0) {
            navItem = navStack[navStack.length - 1];
        }
        var title = 'Documentation Explorer';
        var content;
        if (schema === undefined) {
            // Schema is undefined when it is being loaded via introspection.
            content = React.createElement(
                "div",
                { className: "spinner-container" },
                React.createElement("div", { className: "spinner" })
            );
        } else if (schema === null) {
            // Schema is null when it explicitly does not exist, typically due to
            // an error during introspection.
            content = React.createElement(
                "div",
                { className: "error-container" },
                'No Schema Available'
            );
        } else if (navItem) {
            if (navItem.name === 'Search Results') {
                title = navItem.name;
                content = React.createElement(SearchResults_1.default, { searchValue: navItem.searchValue, schema: schema, onClickType: this.handleClickTypeOrField, onClickField: this.handleClickTypeOrField });
            } else {
                title = navItem.name;
                if (graphql_1.isType(navItem)) {
                    content = React.createElement(TypeDoc_1.default, { key: navItem.name, schema: schema, type: navItem, onClickType: this.handleClickTypeOrField, onClickField: this.handleClickTypeOrField });
                } else {
                    content = React.createElement(FieldDoc_1.default, { key: navItem.name, field: navItem, onClickType: this.handleClickTypeOrField });
                }
            }
        } else if (schema) {
            content = React.createElement(SchemaDoc_1.default, { schema: schema, onClickType: this.handleClickTypeOrField });
        }
        var prevName;
        if (navStack.length === 1) {
            prevName = 'Schema';
        } else if (navStack.length > 1) {
            prevName = navStack[navStack.length - 2].name;
        }
        var shouldSearchBoxAppear = content && (content.type === SearchResults_1.default || content.type === SchemaDoc_1.default);
        return React.createElement(
            "div",
            { className: cx('doc-explorer', {
                    'show-title': Boolean(prevName)
                }), "data-jsx": 1799508982
            },
            React.createElement(_style2.default, {
                styleId: 1799508982,
                css: ".doc-explorer[data-jsx=\"1799508982\"] {border-left: 6px solid rgba(39, 174, 96, 1);}.doc-explorer-contents[data-jsx=\"1799508982\"] {top: 0;box-shadow: none;height: calc(100% - 57px);}.doc-explorer-title-bar[data-jsx=\"1799508982\"] {z-index: 2;}.relative,\n.doc-explorer[data-jsx=\"1799508982\"],\n.doc-explorer-contents[data-jsx=\"1799508982\"] {position: relative;}.h100,\n.doc-explorer[data-jsx=\"1799508982\"] {height: 100%;}.pa0,\n.doc-explorer-contents[data-jsx=\"1799508982\"] {padding: 0;}.overflowYScroll,\n.doc-explorer-contents[data-jsx=\"1799508982\"] {overflow-y: scroll;}.nosb,\n.doc-explorer-contents[data-jsx=\"1799508982\"] {-ms-overflow-style: none;}.nosb::-webkit-scrollbar,\n.doc-explorer-contents[data-jsx=\"1799508982\"]::-webkit-scrollbar {display: none;}.relative,\n.doc-explorer[data-jsx=\"1799508982\"],\n.doc-explorer-contents[data-jsx=\"1799508982\"] {position: relative;}"
            }),
            prevName && React.createElement(
                "div",
                { className: 'doc-explorer-title-bar', "data-jsx": 1799508982
                },
                React.createElement(
                    "div",
                    { className: "doc-explorer-back", onClick: this.handleNavBackClick, "data-jsx": 1799508982
                    },
                    prevName
                ),
                React.createElement(
                    "div",
                    { className: "doc-explorer-title", "data-jsx": 1799508982
                    },
                    title
                )
            ),
            React.createElement(
                "div",
                { className: "doc-explorer-contents", "data-jsx": 1799508982
                },
                React.createElement(
                    "div",
                    { className: "header", "data-jsx": 1799508982
                    },
                    React.createElement(SearchBox_1.default, { isShown: shouldSearchBoxAppear, onSearch: this.handleSearch })
                ),
                content
            )
        );
    };
    // Public API
    DocExplorer.prototype.showDoc = function (typeOrField) {
        var navStack = this.state.navStack;
        var isCurrentlyShown = navStack.length > 0 && navStack[navStack.length - 1] === typeOrField;
        if (!isCurrentlyShown) {
            navStack = navStack.concat([typeOrField]);
        }
        this.setState({ navStack: navStack });
    };
    // Public API
    DocExplorer.prototype.showSearch = function (searchItem) {
        var navStack = this.state.navStack;
        var lastEntry = navStack.length > 0 && navStack[navStack.length - 1];
        if (!lastEntry) {
            navStack = navStack.concat([searchItem]);
        } else if (lastEntry.searchValue !== searchItem.searchValue) {
            navStack = navStack.slice(0, -1).concat([searchItem]);
        }
        this.setState({ navStack: navStack });
    };
    return DocExplorer;
}(React.Component);
exports.DocExplorer = DocExplorer;


//////////////////
// WEBPACK FOOTER
// ./~/graphcool-graphiql/babelbuild/GraphiQL/DocExplorer.js
// module id = ./node_modules/graphcool-graphiql/babelbuild/GraphiQL/DocExplorer.js
// module chunks = 0